import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiDms} from "./dms/UiDms";
import {ErrorMarker} from "./ErrorMarker";

export abstract class BaseEditor extends MuWidget<UiDms, {}, {}> {
	protected id: number | null = null;
	// @ts-ignore
	protected onSaved: (value: any) => void;
	// @ts-ignore
	protected errorMarker: ErrorMarker;
	// @ts-ignore
	public savedPromise: Promise<any>;

	afterIndex() {
		this.savedPromise = new Promise((res) => this.onSaved = res);
		// @ts-ignore
		this.errorMarker = new ErrorMarker(this);
	}

	muRemoveSelf() {
		super.muRemoveSelf();
		this.muDispatchEvent("close");
	}

	beforeIndex() {
		super.beforeIndex();
		this.muRegisterEvent("close");
	}

	container_keypress(ev: KeyboardEvent) {
		if (ev.key === "Enter") {
			ev.preventDefault();
			ev.cancelBubble = true;
			this.ui.bSave?.click();
		}
	}

	public abstract loadItem(id: number): void;
}

export function formGroup(name: string, label: string, input: string, dataFilter: string|true|null = null): string
{
	if (dataFilter === true) dataFilter = name;
	return `<div class="form-group row" mu-id="block_${name}"`
		+ (dataFilter ? ' data-field="' + dataFilter + '"' : '')
		+ `>
		<label mu-for="` + name + `" class="col-sm-3 control-label with-cleaner" mu-id="label_${name}">`
		+ (dataFilter
			? `<span class="label-text">${label}</span><span class="icon-erase cursor-pointer" mu-click='eraseFilterField: "${dataFilter}"'></span>`
			: label)
		+ `</label>
		<div class="col-sm-9">${input}</div>
	</div>`;
}
